import { useTheme } from "@mui/material";

export default function MyFamilyIcon() {
  const theme = useTheme();
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* медицинский крест */}
      <path
        d="M9.16667 0.833344H10.8333V2.50001H12.5V4.16668H10.8333V5.83334H9.16667V4.16668H7.5V2.50001H9.16667V0.833344Z"
        fill={theme.palette.rgd.primary}
      />
      {/* фигура слева (взрослый) */}
      <circle cx="6" cy="10" r="2.08333" fill={theme.palette.rgd.primary} />
      <path
        d="M1.66669 18.3333C1.66669 15.4879 3.71145 13.3333 6.00002 13.3333C7.03372 13.3333 7.98676 13.7607 8.71484 14.4712C7.83127 15.5254 7.27237 16.9091 7.20142 18.3333H1.66669Z"
        fill={theme.palette.rgd.primary}
      />
      {/* фигура справа (ребенок) */}
      <circle cx="13.3334" cy="11.25" r="1.66667" fill={theme.palette.rgd.primary} />
      <path
        d="M9.58337 18.3333C9.58337 15.9971 11.2842 14.1667 13.3334 14.1667C15.3826 14.1667 17.0834 15.9971 17.0834 18.3333H9.58337Z"
        fill={theme.palette.rgd.primary}
      />
    </svg>
  );
}
